module.exports = __webpack_public_path__ + "img/ambassador_hero.8a7bd314.jpeg";